var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgArrowDownUp = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24",
  width: "1em",
  height: "1em"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M16 6.707V18.5a.5.5 0 1 1-1 0V6.707l-3.146 3.147a.5.5 0 0 1-.708-.707l4-4a.5.5 0 0 1 .708 0l4 4a.5.5 0 0 1-.708.707zM9 5.5a.5.5 0 0 0-1 0v11.793l-3.146-3.146a.5.5 0 1 0-.708.707l4 4a.5.5 0 0 0 .708 0l4-4a.5.5 0 0 0-.708-.707L9 17.293z",
  clipRule: "evenodd"
})));
export default SvgArrowDownUp;